module.exports = __webpack_public_path__ + "static/media/notepad2.53049a84.png";